import * as Yup from "yup";

export const addOrUpdateReportCategoriesSchema = Yup.object().shape({
  id: Yup.number().nullable(),
  name: Yup.string()
    .trim()
    .min(1, "Name must contain at least 1 character")
    .required("Name is required"),
});
